import { z } from 'zod';

export const forgotPasswordSchema = z.object({
  email: z.email({ error: 'Please enter a valid email address' }).trim(),
});

export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
